import { Component } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { AdminService } from '../../../../admin.service';
import { IGlossary } from '@shared/interfaces';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-glossary-info',
    templateUrl: './admin-glossary-info.component.html',
    styleUrls: ['./admin-glossary-info.component.scss'],
    standalone: false
})
export class AdminGlossaryInfoComponent extends AdminActionsDirective {
    constructor(adminService: AdminService, dialogService: DialogService, moduleService: ModuleService) {
        super(adminService, dialogService, moduleService);
    }

    get item(): IGlossary {
        return this.selectedItem;
    }
}
